import { Vue } from "vue-property-decorator"
import { commonObjectState } from "~/state/object"
import { IObjectState } from "~/state/types"
import { NewRequester } from "~/core/Requester"
import ObjectHelper from "~/utils/ObjectHelper"

interface IAttentionTemplateState {
  attentionTemplateDetail: IObjectState<any>
}

export const prefix = "template/attention"

export const state = (): IAttentionTemplateState => ({
  attentionTemplateDetail: commonObjectState(),
})
export const getters = {
  getDetail: (state: any) => (): any => {
    return state.attentionTemplateDetail.data || {}
  },
}

export const mutations = {
  updateDetail: (state: IAttentionTemplateState, data) => {
    Vue.set(state, "attentionTemplateDetail", data)
  },
}

export const actions = {
  getDetail: async ({ commit, state }, data) => {
    const path = `updateDetail`
    try {
      commit(path, ObjectHelper.toLoadingStatus(state.attentionTemplateDetail))
      const response = await NewRequester.get<any>(data.url, { ...data })
      commit(
        path,
        ObjectHelper.toObjSuccessStatus(
          state.attentionTemplateDetail,
          response.data
        )
      )
    } catch (e: any) {
      commit(
        path,
        ObjectHelper.toErrorStatus(
          state.attentionTemplateDetail,
          e.response?.data || e
        )
      )
    }
  },
}
